import { SharedModule } from "../../shared/modules/shared.module";
import { GlobalTankQuickFilterComponent } from "./components/global-tank-filters/global-tank-quick-filter.component";
import { TankQuickFiltersComponent } from "./components/global-tank-filters/tank-quick-filters.component";
import { NgModule } from "@angular/core";

@NgModule({
  declarations: [TankQuickFiltersComponent, GlobalTankQuickFilterComponent],
  imports: [SharedModule],
  exports: [TankQuickFiltersComponent],
})
export class TankQuickFiltersModule {}
